import BaseApi from '../BaseApi';

const DataManagementApi = {
  // Chi nhánh
  GetAllBranch: () => {
    return BaseApi.GET('api/CompanyBranch/GetAll');
  },
  CreateBranch: (data: any) => {
    return BaseApi.POST('api/CompanyBranch/Create', data);
  },
  UpdateBranch: (data: any) => {
    return BaseApi.PUT('api/CompanyBranch/Update', data);
  },
  DeleteBranch: (Id: any) => {
    return BaseApi.DELETE(`api/CompanyBranch/Delete?id=${Id}`, null);
  },

  // Khách hàng
  GetCustomerByPage: (page: any, size: any) => {
    return BaseApi.GET(`api/Customer/All?page=${page}&size=${size}`);
  },
  AdvanceSearchCustomer: (page: any, size: any, databody: any) => {
    return BaseApi.GET(`api/Customer/AdvanceSearchCustomer?pageIndex=${page}&pageSize=${size}`, databody);
  },
  CreateCustomer: (data: any) => {
    return BaseApi.POST('api/Customer/Create', data);
  },
  CreateCustomerV2: (data: any) => {
    return BaseApi.POST('api/Customer/CreateV2', data);
  },
  CreateInvoices: (data: any) => {
    return BaseApi.POST('api/InVoice/CreateInvoices', data);
  },
  CreateInvoicesV2: (data: any) => {
    return BaseApi.POST('api/InVoice/CreateInvoicesV2', data);
  },
  ReplaceInvoices: (data: any) => {
    return BaseApi.PUT('api/InVoice/ReplaceInvoices', data);
  },
  ValidateMaKhachHangs: (data: any) => {
    return BaseApi.POST('api/Customer/ValidateMaKhachHangs', data);
  },
  UpdateCustomer: (data: any) => {
    return BaseApi.PUT('api/Customer/Update', data);
  },
  UpdateCustomerV2: (data: any) => {
    return BaseApi.PUT('api/Customer/UpdateV2', data);
  },
  ReplaceCustomerDebt: (maKH: any, data: any) => {
    return BaseApi.POST(`api/Customer/ReplaceCustomerDebt?maKhachHang=${maKH}`, data);
  },
  UpdateInvoices: (data: any, id: any) => {
    return BaseApi.PUT(`api/Invoice/UpdateInvoices?id=${id}`, data);
  },
  UpdateInvoicesV2: (data: any) => {
    return BaseApi.PUT('api/Invoice/UpdateInvoicesV2', data);
  },
  DeleteCustomer: (Id: any) => {
    return BaseApi.DELETE(`api/Customer/Delete?id=${Id}`, null);
  },
  DeleteInvoices: (Id: any) => {
    return BaseApi.DELETE(`api/InVoice/DeleteInvoices?id=${Id}`, null);
  },
  DeleteInvoiceV2: (Id: any) => {
    return BaseApi.DELETE(`api/InVoice/DeleteInvoiceV2?Id=${Id}`, null);
  },
  SearchCustomer: (textValue: any) => {
    return BaseApi.GET(`api/Customer/Search?searchText=${textValue}`); // chậm quá k sài
  },
  GetAdjustmentTypes: () => {
    return BaseApi.GET('api/Order/GetAdjustmentTypes'); // chậm quá k sài
  },
  SearchCustomerV2: (textValue: any) => {
    return BaseApi.GET(`api/Customer/SearchV2?searchText=${textValue}`); // chậm quá k sài
  },
  SearchCustomerByPhone: (phoneNumber: any) => {
    return BaseApi.GET(`api/Customer/FindByPhone?phoneNumber=${phoneNumber}`);
  },
  GetListCSKH: () => {
    return BaseApi.GET('api/Auth/GetListCSKH');
  },
  CheckCoopWithPhone: (phone: any) => {
    return BaseApi.GET(`api/Customer/CheckCoopWithPhone?phone=${phone}`);
  },
  BlockByPhone: (data: any) => {
    return BaseApi.POST('api/Customer/BlockByPhone', data);
  },
  BlockByCustomerId: (data: any) => {
    return BaseApi.POST('api/Customer/BlockByCusId', data);
  },
  CheckBlockByPhone: (phone: any) => {
    return BaseApi.GET(`api/Customer/CheckBlockByPhone?phone=${phone}`);
  },
  CheckBlockByCusId: (customerId: any) => {
    return BaseApi.GET(`api/Customer/CheckBlockByCusId?phone=${customerId}`);
  },

  // Vùng kỹ thuật (phân vùng hoạt động của kỹ thuật)
  GetAllTechnicianZone: () => {
    return BaseApi.GET('api/TechnicianZone/GetAll');
  },
  CreateTechnicianZone: (data: any) => {
    return BaseApi.POST('api/TechnicianZone/Create', data);
  },
  UpdateTechnicianZone: (data: any) => {
    return BaseApi.PUT('api/TechnicianZone/Update', data);
  },
  DeleteTechnicianZone: (Id: any) => {
    return BaseApi.DELETE(`api/TechnicianZone/Delete?id=${Id}`, null);
  }

  // Kho

  // Nhà cung cấp...
};

export default DataManagementApi;
